const WYSIWYGTable = require('./modules/wysiwyg-table.js');
new WYSIWYGTable();